import { render, staticRenderFns } from "./iFooter.vue?vue&type=template&id=3faa63cd&scoped=true"
import script from "./iFooter.vue?vue&type=script&lang=js"
export * from "./iFooter.vue?vue&type=script&lang=js"
import style0 from "./iFooter.vue?vue&type=style&index=0&id=3faa63cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa63cd",
  null
  
)

export default component.exports